/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SearchActions, Spacer } from 'sarsaparilla';

import { HomePageContent } from '../../components/homepage/HomePageContent';
import { useAppDispatch } from '../../redux/redux-helpers';

export function HomePageContainer() {
    const dispatch = useAppDispatch();

    return (
        <>
            <HomePageContent
                submitSimpleSearch={(...args) => {
                    dispatch(SearchActions.submitSimpleSearch(...args));
                }}
            />

            <Spacer size="xxl" />
        </>
    );
}

export default HomePageContainer;
